import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import { isObjectEmpty } from '../utils';

interface ISetDatadogSessionUser {
  id?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  [key: string]: unknown;
}

class DatadogService {
  public init = () => {
    try {
      if (!isObjectEmpty(DATADOG)) {
        datadogRum.init({
          applicationId: DATADOG.APPLICATION_ID,
          clientToken: DATADOG.CLIENT_TOKEN,
          env: DATADOG.ENV,
          site: DATADOG.SITE,
          service: DATADOG.SERVICE,
          sampleRate: DATADOG.SAMPLE_RATE,
          trackInteractions: DATADOG.TRACK_INTERACTIONS,
          defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
        });
      }
    } catch (error) {
      console.warn('datadog initialize error', error);
    }
  };

  public setUser = (datadogSessionUser: ISetDatadogSessionUser) => {
    datadogRum.setUser(datadogSessionUser);
  };

  public removeUser = () => {
    datadogRum.removeUser();
  };

  public createError = (error: unknown, context?: object) => {
    datadogRum.addError(error, context);
  };

  public createAction = (name: string, context?: object) => {
    datadogRum.addAction(name, context);
  };
}

export default new DatadogService();
